module.exports = __webpack_public_path__ + "static/media/thumbnail.84284e25.jpg";